import { TemplatePage } from './types';

const live_streaming_ended_screen: TemplatePage = {
  header: {
    color: '#FEE686',
    icon: 'images/video-templates/stream_outro.jpg',
    title: '‘Stream Ended’ Screen Templates',
    title_meta: '‘Stream Ended’ Screen Video Templates',
    description_meta:
      'Explore our diverse collection of customizable “stream ended” screen templates, perfect' +
      ' for wrapping up your live streams in style. Try now!',
    description:
      'Explore our diverse collection of customizable “stream ended” screen templates, perfect' +
      ' for wrapping up your live streams in style. Impress your audience with professionally' +
      ' designed stream ending screens that are easy to edit and adapt to your brand.'
  },
  footer: {
    category: 'Live streaming outro',
    description:
      'Wave.video offers a vast variety of easy-to-edit “stream ended” screen templates that can' +
      ' be customized to fit your brand and message. Designed to leave a lasting impression on your' +
      ' viewers, these professionally crafted templates will give your streams a polished finish.' +
      ' Customize our stream ending screen templates with ease and effortlessly match your brand' +
      ' identity. Elevate your live streaming experience today and keep your audience coming back' +
      ' for more.'
  },
  content: [
    {
      type: 'templates',
      title: 'Live Streaming Ended Screen',
      search: { name: 'LiveOutro', tags: 'LiveOutro' }
    },
    {
      type: 'stocks',
      title: 'the end',
      search: { name: 'the end' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_ended_screen;
